import { createContext } from 'react';

import { ValueRepresentation } from '../../core/types/scales.js';

export const TimeseriesChartValueRepresentation = createContext<
  ValueRepresentation | undefined
>(undefined);

TimeseriesChartValueRepresentation['displayName'] =
  'TimeseriesChartValueRepresentation';
